if (__DEV__) {
  require('./components/ApplicationConfigurationContainer');
}

import ApplicationWizardContainer from '../application-wizard/components/ApplicationWizardContainer';
// eslint-disable-next-line max-len
import ApplicationDetailsPage from '../application-wizard/pages/application-details/components/ApplicationDetailsPage';

export default store => ({
  path: 'configuration',

  getComponent(nextState, cb) {
    import(/* webpackChunkName: "applications" */
    './components/ApplicationConfigurationContainer')
      .then(loadRoute(cb))
      .catch(errorLoading);
  },

  childRoutes: [
    {
      path: 'edit',
      indexRoute: {
        onEnter: (nextState, replace) =>
          replace(`${nextState.location.pathname}/details`)
      },
      component: ApplicationWizardContainer,
      childRoutes: [
        {
          path: 'details',
          component: ApplicationDetailsPage
        }
      ]
    }
  ]
});

function errorLoading(err) {
  console.error('Dynamic page loading failed', err);
}

function loadRoute(cb) {
  return module => cb(null, module.default);
}



// WEBPACK FOOTER //
// ./src/client/plugins/applications/pages/application-configuration/index.js